<template>
    <b-row
        :align-h="horizontalAlign"
        :align-v="verticalAlign"
        :cols="cols"
        @click="$emit('click', $event)"
    >
        <slot />
    </b-row>
</template>

<script>
import { BRow } from 'bootstrap-vue'

export default {
    components: { BRow },
    props: {
        cols: { type: String },
        horizontalAlign: { type: String, default: null },
        verticalAlign: { type: String, default: null },
    }
}
</script>